import scrollDir from "scrolldir";

export default () => {

    scrollDir({

    });

}
